import { render, staticRenderFns } from "./Unresolved.vue?vue&type=template&id=0c75801c&"
import script from "./Unresolved.vue?vue&type=script&lang=js&"
export * from "./Unresolved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports